/**
 * 数据报表路由
 */
const routesDataReport = [
  {
    path: "/dataReport",
    name: "dataReport",
    redirect: "/dataReport/botStatistics",
    component: () => import("@/views/dataReport/navigationDataReport.vue"),
    meta: {
      title: "route.data-report",
      crumbs: "route.data-report-crumb",
      isLogin: true,
      // 数据报表当前只有一个报表页，直接作为一级菜单入口，不再生成二级菜单。
      sidebar: { label: "数据报表", labelKey: "route.data-report", icon: "Analysis", order: 90 },
    },
    children: [
      {
        // 兼容历史二级菜单地址，旧链接访问时回到一级数据报表。
        path: "/dataReport/botStatistics",
        name: "dataReportCenter",
        component: () => import("@/views/dataReport/statistics.vue"),
        meta: {
          title: "route.robot-report",
          crumbs: "route.data-report-crumb",
          isLogin: true,
          sidebar: {label: "机器人报表", labelKey: "route.robot-report", icon: "RobotReport", order: 91},
        },
      },
      {
        path: "/dataReport/mail-bot-statistics",
        name: "MailBotStatistics",
        component: () => import("@/views/dataReport/MailBotStatistics.vue"),
        meta: {
          title: "route.mail-bot-statistics",
          crumbs: "route.data-report-crumb",
          isLogin: true,
          sidebar: {label: "邮箱机器人统计", labelKey: "route.mail-bot-statistics", icon: "EmailStats", order: 91},
        }
      },
      {
        path: "/dataReport/ctwa",
        name: "CTWA",
        component: () => import("@/views/dataReport/CTWA.vue"),
        meta: {
          title: "route.CTWAReport",
          crumbs: "route.data-report-crumb",
          isLogin: true,
          sidebar: {
            label: "CTWA 报表",
            labelKey: "route.CTWAReport",
            icon: "MenuCTWA",
            order: 92
          }
        }
      },
      {
        path: "/dataReport/ctwa/:account_id",
        name: "CTWADetail",
        component: () => import("@/views/dataReport/CTWA/CTWADetail.vue"),
        meta: {
          title: "route.CTWA-Detail",
          isLogin: true,
        }
      }
    ]
  },
];

export default routesDataReport;
